// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var SlTpPriceType;
(function (SlTpPriceType) {
    SlTpPriceType[SlTpPriceType["Absolute"] = 0] = "Absolute";
    SlTpPriceType[SlTpPriceType["Offset"] = 1] = "Offset";
    SlTpPriceType[SlTpPriceType["TrOffset"] = 2] = "TrOffset";
    SlTpPriceType[SlTpPriceType["ProtectiveAbsolute"] = 3] = "ProtectiveAbsolute";
    SlTpPriceType[SlTpPriceType["Percent"] = 4] = "Percent";
})(SlTpPriceType || (SlTpPriceType = {}));
export var DirectPropertyOwner;
(function (DirectPropertyOwner) {
    DirectPropertyOwner[DirectPropertyOwner["Unspecified"] = -1] = "Unspecified";
    DirectPropertyOwner[DirectPropertyOwner["Settings"] = 0] = "Settings";
    DirectPropertyOwner[DirectPropertyOwner["Group"] = 1] = "Group";
    DirectPropertyOwner[DirectPropertyOwner["User"] = 2] = "User";
    DirectPropertyOwner[DirectPropertyOwner["Branding"] = 3] = "Branding";
    DirectPropertyOwner[DirectPropertyOwner["Account"] = 4] = "Account";
    DirectPropertyOwner[DirectPropertyOwner["Local"] = 5] = "Local";
    DirectPropertyOwner[DirectPropertyOwner["FeautreFlags"] = 97] = "FeautreFlags";
})(DirectPropertyOwner || (DirectPropertyOwner = {}));
export var Leve2QuoteType;
(function (Leve2QuoteType) {
    /// <summary>
    ///  обычная котировка
    /// </summary>
    Leve2QuoteType[Leve2QuoteType["None"] = 0] = "None";
    /// <summary>
    /// индикативная будет использоваться в B3 и Bovespa market data роутах - означает, что при сортировке такие котировки подымаются на верх стакана
    /// </summary>
    Leve2QuoteType[Leve2QuoteType["Indicative"] = 1] = "Indicative";
    /// <summary>
    /// перемещаем вниз стакана ( прочерк ) используется на индийском рынке.
    /// </summary>
    Leve2QuoteType[Leve2QuoteType["WithoutPrice"] = 2] = "WithoutPrice";
})(Leve2QuoteType || (Leve2QuoteType = {}));
export var Level2Update;
(function (Level2Update) {
    Level2Update[Level2Update["Incremental"] = 0] = "Incremental";
    Level2Update[Level2Update["FullRefresh"] = 1] = "FullRefresh";
})(Level2Update || (Level2Update = {}));
// 0-бай, 1-селл
export var AgressorFlagType;
(function (AgressorFlagType) {
    AgressorFlagType[AgressorFlagType["None"] = -1] = "None";
    AgressorFlagType[AgressorFlagType["Ask"] = 0] = "Ask";
    AgressorFlagType[AgressorFlagType["Bid"] = 1] = "Bid";
    AgressorFlagType[AgressorFlagType["CrossTrade"] = 2] = "CrossTrade";
    AgressorFlagType[AgressorFlagType["Auction"] = 3] = "Auction";
    AgressorFlagType[AgressorFlagType["RLP"] = 4] = "RLP";
    AgressorFlagType[AgressorFlagType["NotSet"] = 255] = "NotSet";
})(AgressorFlagType || (AgressorFlagType = {}));
export var ReportMessageImportanceLevel;
(function (ReportMessageImportanceLevel) {
    ReportMessageImportanceLevel[ReportMessageImportanceLevel["Normal"] = 0] = "Normal";
    ReportMessageImportanceLevel[ReportMessageImportanceLevel["Important"] = 1] = "Important";
    ReportMessageImportanceLevel[ReportMessageImportanceLevel["Critical"] = 2] = "Critical";
})(ReportMessageImportanceLevel || (ReportMessageImportanceLevel = {}));
export var ReportMessageSource;
(function (ReportMessageSource) {
    ReportMessageSource[ReportMessageSource["Unknown"] = 0] = "Unknown";
    ReportMessageSource[ReportMessageSource["BusinessRejectMessage"] = 1] = "BusinessRejectMessage";
    ReportMessageSource[ReportMessageSource["OpenOrderMessage"] = 2] = "OpenOrderMessage";
    ReportMessageSource[ReportMessageSource["MarginCallMessage"] = 3] = "MarginCallMessage";
    ReportMessageSource[ReportMessageSource["AccountOperationMessage"] = 4] = "AccountOperationMessage";
    ReportMessageSource[ReportMessageSource["AccountStatusMessage"] = 5] = "AccountStatusMessage";
})(ReportMessageSource || (ReportMessageSource = {}));
export var SessionOperations;
(function (SessionOperations) {
    SessionOperations[SessionOperations["None"] = 0] = "None";
    SessionOperations[SessionOperations["Open"] = 1] = "Open";
    SessionOperations[SessionOperations["Modify"] = 2] = "Modify";
    SessionOperations[SessionOperations["Cancel"] = 4] = "Cancel";
})(SessionOperations || (SessionOperations = {}));
export var InformationMessageType;
(function (InformationMessageType) {
    InformationMessageType[InformationMessageType["Info"] = 0] = "Info";
    InformationMessageType[InformationMessageType["ErrorReport"] = 1] = "ErrorReport";
    InformationMessageType[InformationMessageType["Settings"] = 2] = "Settings";
    InformationMessageType[InformationMessageType["LoginCA"] = 3] = "LoginCA";
    InformationMessageType[InformationMessageType["TradeCA"] = 4] = "TradeCA";
})(InformationMessageType || (InformationMessageType = {}));
export var RevenuePlanMessageType;
(function (RevenuePlanMessageType) {
    RevenuePlanMessageType[RevenuePlanMessageType["Spread"] = 0] = "Spread";
    RevenuePlanMessageType[RevenuePlanMessageType["Comission"] = 1] = "Comission";
})(RevenuePlanMessageType || (RevenuePlanMessageType = {}));
export var RevenueCommissionType;
(function (RevenueCommissionType) {
    RevenueCommissionType[RevenueCommissionType["None"] = 0] = "None";
    RevenueCommissionType[RevenueCommissionType["FixedFee"] = 1] = "FixedFee";
    RevenueCommissionType[RevenueCommissionType["Percentage"] = 2] = "Percentage";
    RevenueCommissionType[RevenueCommissionType["FixedAndPercentage"] = 3] = "FixedAndPercentage";
})(RevenueCommissionType || (RevenueCommissionType = {}));
export var CommissionDefaultAsset;
(function (CommissionDefaultAsset) {
    CommissionDefaultAsset[CommissionDefaultAsset["INSTRUMENT_QUOTING_CCY"] = -2] = "INSTRUMENT_QUOTING_CCY";
    CommissionDefaultAsset[CommissionDefaultAsset["INSTRUMENT_BASE_CCY"] = -1] = "INSTRUMENT_BASE_CCY";
})(CommissionDefaultAsset || (CommissionDefaultAsset = {}));
export var SubscribeType;
(function (SubscribeType) {
    SubscribeType[SubscribeType["SUBSCRIBE"] = 0] = "SUBSCRIBE";
    SubscribeType[SubscribeType["UNSUBSCRIBE"] = 1] = "UNSUBSCRIBE";
})(SubscribeType || (SubscribeType = {}));
export var SubscriptionSource;
(function (SubscriptionSource) {
    SubscriptionSource[SubscriptionSource["NORMAL"] = 0] = "NORMAL";
    SubscriptionSource[SubscriptionSource["DATASOURCE"] = 1] = "DATASOURCE";
})(SubscriptionSource || (SubscriptionSource = {}));
export var MarginModes;
(function (MarginModes) {
    MarginModes[MarginModes["USE_LOSS"] = 0] = "USE_LOSS";
    MarginModes[MarginModes["USE_PROFIT_LOSS"] = 1] = "USE_PROFIT_LOSS";
    MarginModes[MarginModes["USE_PROFIT_IN_MARGIN_AVAILABLE"] = 2] = "USE_PROFIT_IN_MARGIN_AVAILABLE";
    /* USE_PROFIT_LOSS,
    USE_PROFIT,
    USE_LOSS,
    DO_NOT_USE_PROFIT_LOSS */
})(MarginModes || (MarginModes = {}));
export const SEPARATOR = ':';
export var CloseAccountResponseStatus;
(function (CloseAccountResponseStatus) {
    CloseAccountResponseStatus[CloseAccountResponseStatus["New"] = 0] = "New";
    CloseAccountResponseStatus[CloseAccountResponseStatus["Approve"] = 1] = "Approve";
    CloseAccountResponseStatus[CloseAccountResponseStatus["Rejected"] = 2] = "Rejected";
    CloseAccountResponseStatus[CloseAccountResponseStatus["Cancelled"] = 3] = "Cancelled";
})(CloseAccountResponseStatus || (CloseAccountResponseStatus = {}));
export var CrossRateForPositions;
(function (CrossRateForPositions) {
    CrossRateForPositions[CrossRateForPositions["Default"] = 0] = "Default";
    CrossRateForPositions[CrossRateForPositions["LatestBidAsk"] = 1] = "LatestBidAsk";
})(CrossRateForPositions || (CrossRateForPositions = {}));
